<div style="display: block; width: 50%; margin-left: 5rem">

  <mat-label>Lower Chart Data Limit </mat-label>
  <mat-slider
    thumbLabel
    [displayWith]="formatLabel"
    tickInterval="1"
    [(ngModel)]="limit"
    (change)="setLimit($any($event).value)"
    [step]="step"
    [min]="min"
    [max]="max"
    aria-label="units"></mat-slider> {{limit}}
</div>

<div style="display: block; width: 100%">
  <canvas baseChart #chart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [legend]="barChartLegend"
          chartType="bar">
  </canvas>
</div>

